module.exports = __webpack_public_path__ + "statics/img/13.9106cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/13.png
// module id = Ym+a
// module chunks = 1